import { apiFetch } from './api';
import { getOrCreateDeviceId } from './deviceId';

function getClientLabel(): string {
  const nav = navigator as { userAgentData?: { brands?: { brand: string; version: string }[]; platform?: string } };
  if (nav.userAgentData?.brands?.length) {
    // Modern Chrome/Edge — use high-entropy brand
    const brand = nav.userAgentData.brands.find(b => !b.brand.includes('Not'))
      ?? nav.userAgentData.brands[0];
    const platform = nav.userAgentData.platform ?? 'Unknown';
    return `${brand.brand} ${brand.version} / ${platform}`;
  }
  // Fallback: extract from UA string
  const ua = navigator.userAgent;
  let browser = 'Unknown';
  if (ua.includes('Firefox/')) {
    const m = ua.match(/Firefox\/([\d]+)/);
    browser = m ? `Firefox ${m[1]}` : 'Firefox';
  } else if (ua.includes('Edg/')) {
    const m = ua.match(/Edg\/([\d]+)/);
    browser = m ? `Edge ${m[1]}` : 'Edge';
  } else if (ua.includes('Chrome/')) {
    const m = ua.match(/Chrome\/([\d]+)/);
    browser = m ? `Chrome ${m[1]}` : 'Chrome';
  } else if (ua.includes('Safari/')) {
    const m = ua.match(/Version\/([\d]+)/);
    browser = m ? `Safari ${m[1]}` : 'Safari';
  }
  let os = 'Unknown';
  if (ua.includes('Mac OS X')) os = 'macOS';
  else if (ua.includes('Windows')) os = 'Windows';
  else if (ua.includes('Linux')) os = 'Linux';
  else if (ua.includes('Android')) os = 'Android';
  else if (ua.includes('iPhone') || ua.includes('iPad')) os = 'iOS';
  return `${browser} / ${os}`;
}

let lastReportedUserId: string | null = null;

export function reportDeviceSeen(token: string, userId: string): void {
  if (userId === lastReportedUserId) return;
  const installId = getOrCreateDeviceId();
  if (!installId) return; // fail closed — no persistent storage available
  void apiFetch('/user/device-seen', {
    method: 'POST',
    token,
    body: { install_id: installId, platform: 'web', client_label: getClientLabel() },
  }).then(() => { lastReportedUserId = userId; }).catch(() => {});
}
